import React, { useState } from "react";
import "./LoginSignupModal.css";
import { auth, provider } from "./firebase";
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signInWithPopup
} from "firebase/auth";

const LoginSignupModal = ({ onClose, initialTab = 'login', onSignupSuccess }) => {
  const [isLogin, setIsLogin] = useState(initialTab === 'login');
  const [formData, setFormData] = useState({ email: "", password: "", confirmPassword: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateForm = () => {
    const { email, password, confirmPassword } = formData;

    if (!email || !password || (!isLogin && !confirmPassword)) {
      return "All fields are required.";
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) return "Enter a valid email.";

    if (password.length < 6) return "Password must be at least 6 characters.";

    if (!isLogin && password !== confirmPassword) return "Passwords do not match.";

    return "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationError = validateForm();
    if (validationError) {
      setError(validationError);
      return;
    }

    setError("");
    setLoading(true);

    const { email, password } = formData;

    try {
      if (isLogin) {
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        console.log("Logged in:", userCredential.user);
        // You can add any login success action here
        alert("Login successful!");  // If you want, later can replace with custom popup as well
        onClose();
      } else {
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        console.log("Signed up:", userCredential.user);
        onClose();
        // Notify parent of signup success so it can show custom popup
        if (onSignupSuccess) onSignupSuccess();
      }
    } catch (err) {
      console.error(err.message);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleSignIn = async () => {
    setError("");
    setLoading(true);
    try {
      const result = await signInWithPopup(auth, provider);
      console.log("Google signed in:", result.user);
      alert("Logged in with Google!");
      onClose();
    } catch (err) {
      console.error(err.message);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" role="dialog" aria-modal="true" aria-labelledby="modalTitle">
        <h2 id="modalTitle">{isLogin ? "Login" : "Sign Up"}</h2>
        {error && <p className="error">{error}</p>}
        <form onSubmit={handleSubmit} aria-describedby="formInstructions">
          <input
            type="email"
            name="email"
            placeholder="Email"
            onChange={handleChange}
            value={formData.email}
            required
            disabled={loading}
            aria-label="Email"
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            onChange={handleChange}
            value={formData.password}
            required
            disabled={loading}
            aria-label="Password"
          />
          {!isLogin && (
            <input
              type="password"
              name="confirmPassword"
              placeholder="Confirm Password"
              onChange={handleChange}
              value={formData.confirmPassword}
              required
              disabled={loading}
              aria-label="Confirm Password"
            />
          )}
          <button type="submit" disabled={loading}>
            {loading ? (isLogin ? "Logging in..." : "Signing up...") : (isLogin ? "Login" : "Sign Up")}
          </button>
        </form>

        <button onClick={handleGoogleSignIn} className="google-btn" disabled={loading} aria-label="Sign in with Google">
          Sign in with Google
        </button>

        <p className="switch-text">
          {isLogin ? "Don't have an account?" : "Already have an account?"}{" "}
          <span onClick={() => { if(!loading) setIsLogin(!isLogin) }}>
            {isLogin ? "Sign Up" : "Login"}
          </span>
        </p>

        <button className="close-btn" onClick={onClose} aria-label="Close modal" disabled={loading}>
          ✕
        </button>
      </div>
    </div>
  );
};

export default LoginSignupModal;
